/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */

import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Subject ,  Observable } from 'rxjs';

@Injectable()
export class AuditLogsSerivce {
  private auditLogUrl: string = environment.host + '/audit/filter';
  private auditReportUrl: string = environment.host + '/report/AuditTrail';
  public flagsUrl: string = environment.host + '/flag/metadata'
  public invokeCancelRequest: Observable<any>;
  public isCancelRequest: Subject<any>;

  constructor(private http: HttpClient) {
    this.isCancelRequest = new Subject<boolean>();
    this.invokeCancelRequest = this.isCancelRequest.asObservable();
  }

  public cancelRequest(val: any) {
    this.isCancelRequest.next(val);
  }

  public getAllAuditLogs(payload: any, startRecord: any, recordsSize: any) {
    const filterURL = this.auditLogUrl + '?pageMaxId=' + startRecord + '&size=' + recordsSize;
    return this.http.post(filterURL, payload).pipe(
      map(response => response))
  }

  public getReportDetails() {
    const auditReportUrl = this.auditReportUrl;
    return this.http.get(auditReportUrl).toPromise();
  }

  public getFlagDetails() {
    const auditFlagUrl = this.flagsUrl;
    return this.http.get(auditFlagUrl).toPromise();
  }
}
